import { Injectable } from '@angular/core';
import {
  MonthlyIncome,
  MonthlyExpense,
  LiquidAssets,
  Liabilities,
  Assets,
  FinancialAssets,
  TangibleAssets,
  PersonalAssets,
  RetirementAssets,
  LifeInsurance,
  HealthInsurance
} from '../core/checkup';
import { Investor } from '../modules/shared/models/investor';

@Injectable()
export class CalcService {
  constructor() {}

  totalMonthlyIncome(income: MonthlyIncome): number {
    return (
      income.professionalIncome +
      income.salaryRemuneration +
      income.rentalIncome +
      income.interestDividend +
      income.miscIncome
    );
  }
  totalAnnualIncome(income: MonthlyIncome): number {
    return this.totalMonthlyIncome(income) * 12;
  }

  totalMonthlyExpense(expense: MonthlyExpense): number {
    return (
      expense.accomodation +
      expense.donations +
      expense.education +
      expense.financialSecurity +
      expense.food +
      expense.furnitureEquipments +
      expense.gifts +
      expense.healthCare +
      expense.houseHoldOperations +
      expense.incomeTax +
      expense.leisureEntertainment +
      expense.misc +
      expense.personalCare +
      expense.shortTermLoan +
      expense.style +
      expense.tobaccoAlcohol +
      expense.transportation
    );
  }

  totalAnnualExpense(expense: MonthlyExpense): number {
    return this.totalMonthlyExpense(expense) * 12;
  }

  totalLiquidAssets(assets: LiquidAssets): number {
    return (
      assets.coh.amount + assets.liquidFunds.amount + assets.savingsAc.amount
    );
  }

  totalFinnancialAssets(assets: FinancialAssets): number {
    return (
      assets.bankFD.amount +
      assets.cashValueOfLIP.amount +
      assets.corporateFD.amount +
      assets.directEquity.amount +
      assets.esop.amount +
      assets.fixedIncome.amount +
      assets.marketableInstruments.amount +
      assets.mutualFunds.amount +
      assets.nbfcFD.amount +
      assets.otherFixedIncomeProducts.amount +
      assets.otherMarketableInstruments.amount +
      assets.postalInstruments.amount +
      assets.PrivateEquity.amount
    );
  }

  totalTangibleAssets(assets: TangibleAssets): number {
    return (
      assets.officeShop.amount +
      assets.otherProperties.amount +
      assets.plotLand.amount
    );
  }

  totalPersonalAssets(assets: PersonalAssets): number {
    return (
      assets.carVehicles.amount +
      assets.jewellery.amount +
      assets.otherPersonalAssets.amount +
      assets.primaryHouse.amount +
      assets.vaccationHome.amount
    );
  }

  totalRetirementAssets(assets: RetirementAssets): number {
    return (
      assets.cashValueOfPensionPlan.amount +
      assets.gratuity.amount +
      assets.pf.amount +
      assets.ppf.amount +
      assets.saf.amount
    );
  }

  totalAssets(investor: Investor): number {
    return (
     investor.total_liquid_assets_value +
      investor.total_financial_assets_value +
      investor.total_tangile_assets_value +
      investor.total_retirement_assets_value
    );
  }

  totalLiabilities(liabilities: Liabilities): number {
    return (
      liabilities.carLoan +
      liabilities.creditCardDues +
      liabilities.homeLoan +
      liabilities.incomeTaxPayable +
      liabilities.shortTermLoan
    );
  }
  totalLifeInsurance(insurance: LifeInsurance): number {
    return (
      insurance.adequateInsurance +
      insurance.existingLICoverage +
      insurance.pureRiskPlan
    );
  }

  totalHealthInsurance(insurance: HealthInsurance): number {
    return (
      insurance.basicPlan +
      insurance.comprehensivePlan
    );
  }


}




// WEBPACK FOOTER //
// ./src/app/services/calc.service.ts